import React, { useEffect, useState } from 'react';
import { Menu, X, ChevronDown } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function Navigation() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [platformDropdownOpen, setPlatformDropdownOpen] = useState(false);
  const [companyDropdownOpen, setCompanyDropdownOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navItems = ['Contact'];
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white/95 backdrop-blur-sm shadow-sm border-b border-line py-3' : 'bg-white border-b border-line py-4'}`} data-id="element-1214" data-mp="f02a7iwss4v9">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1215" data-mp="ozt6nq4x4txz">
        <div className="flex justify-between items-center" data-id="element-1216" data-mp="dfz63log9bjp">
          {/* Logo Area */}
          <div className="flex items-center" data-id="element-1217" data-mp="hhaz816j8ewn">
            <a href="/" className="flex items-center" aria-label="SyNeural home" data-id="element-1218" data-mp="hi2h6977ie4g">
              <img src="https://cdn.magicpatterns.com/uploads/pa3Fk96C6qU6AFqdF9EfnU/ChatGPT_Image_Aug_25,_2026,_10_57_05_AMff.png" alt="SyNeural — Creating an Intelligent Web" className={`w-auto transition-all duration-200 ${isScrolled ? 'h-8' : 'h-10'}`} data-id="element-1219" data-mp="mg4admycjttn" />
            </a>
          </div>

          {/* Desktop Nav */}
          <nav className="hidden lg:flex items-center gap-8" data-id="element-1220" data-mp="15755u109d78g">
            <ul className="flex items-center gap-6" data-id="element-1221" data-mp="158yhjupqahnb">
              {/* Platform Dropdown */}
              <li className="relative" data-id="element-1222" data-mp="1a56ur2kd80ru">
                <button onMouseEnter={() => setPlatformDropdownOpen(true)} onMouseLeave={() => setPlatformDropdownOpen(false)} className="text-sm font-medium text-ink-muted hover:text-navy transition-colors flex items-center gap-1" aria-expanded={platformDropdownOpen} data-id="element-1223" data-mp="1f5l1mha8d4oa">
                  Products
                  <ChevronDown size={14} className={`transition-transform ${platformDropdownOpen ? 'rotate-180' : ''}`} data-id="element-1224" data-mp="145tpbvtf7erl" />
                </button>

                <AnimatePresence data-id="element-1225" data-mp="1d68b0waaqvvm">
                  {platformDropdownOpen && <motion.div initial={{
                  opacity: 0,
                  y: -10
                }} animate={{
                  opacity: 1,
                  y: 0
                }} exit={{
                  opacity: 0,
                  y: -10
                }} transition={{
                  duration: 0.2
                }} onMouseEnter={() => setPlatformDropdownOpen(true)} onMouseLeave={() => setPlatformDropdownOpen(false)} className="absolute top-full left-0 mt-2 w-80 bg-white rounded-lg shadow-lg border border-line py-2" data-id="element-1226" data-mp="1d8bas81943dj">
                      <a href="/human-capability" className="block px-4 py-2 text-sm text-ink-dark hover:bg-surface-muted transition-colors" data-id="element-1227" data-mp="1pn9k45povkzf">
                        <div className="font-semibold" data-id="element-1228" data-mp="1kprb6fbo95rf">Human Capability Platform</div>
                        <div className="text-xs text-ink-muted" data-id="element-1229" data-mp="1knodra86waco">
                          Reasoning, judgment & leadership readiness
                        </div>
                      </a>
                      <div className="ml-4 border-l border-line" data-id="element-1230" data-mp="1brfebvk7pbqj">
                        <a href="/cji" className="block pl-4 pr-4 py-1.5 text-sm text-ink-dark hover:bg-surface-muted transition-colors" data-id="element-1231" data-mp="315kft01kl5k1">
                          <span className="font-semibold" data-id="element-1232" data-mp="160bbvnbhi5s7">CJI</span>
                          <span className="text-ink-muted" data-id="element-1233" data-mp="1132rdg2v5pns"> · Civic Judgment Index</span>
                        </a>
                        <a href="/ncji" className="block pl-4 pr-4 py-1.5 text-sm text-ink-dark hover:bg-surface-muted transition-colors" data-id="element-1234" data-mp="wz3hvhg03r3x">
                          <span className="font-semibold" data-id="element-1235" data-mp="n3jlktxiyqen">NCJI</span>
                          <span className="text-ink-muted" data-id="element-1236" data-mp="iagyn4n96f7f"> · Neurocognitive Index</span>
                        </a>
                      </div>
                      <a href="/semantic-knowledge" className="block px-4 py-2 mt-1 text-sm text-ink-dark hover:bg-surface-muted transition-colors" data-id="element-1237" data-mp="da2qznpkd79x">
                        <div className="font-semibold" data-id="element-1238" data-mp="3vibpv0z3t9ce">Semantic Knowledge Platform</div>
                        <div className="text-xs text-ink-muted" data-id="element-1239" data-mp="2azztzdslmjgq">
                          Connected evidence & knowledge graphs
                        </div>
                      </a>
                      <div className="border-t border-line my-2" data-id="element-1240" data-mp="2g17078f3fala"></div>
                      <a href="/solutions" className="block px-4 py-2 text-sm text-ink-dark hover:bg-surface-muted transition-colors" data-id="element-1241" data-mp="2kzi7pchx190c">
                        <div className="font-semibold" data-id="element-1242" data-mp="1sb2zb8tahoxz">Solutions</div>
                        <div className="text-xs text-ink-muted" data-id="element-1243" data-mp="1x7t9xgmbrsc0">
                          Applications & Use Cases
                        </div>
                      </a>
                    </motion.div>}
                </AnimatePresence>
              </li>

              {/* Company Dropdown */}
              <li className="relative" data-id="element-1244" data-mp="19i8s511wr14b">
                <button onMouseEnter={() => setCompanyDropdownOpen(true)} onMouseLeave={() => setCompanyDropdownOpen(false)} className="text-sm font-medium text-ink-muted hover:text-navy transition-colors flex items-center gap-1" data-id="element-1245" data-mp="19h7fis58u6kh">
                  Company
                  <ChevronDown size={14} className={`transition-transform ${companyDropdownOpen ? 'rotate-180' : ''}`} data-id="element-1246" data-mp="2qlucpa28p837" />
                </button>

                <AnimatePresence data-id="element-1247" data-mp="1xw5ef4gwzm5a">
                  {companyDropdownOpen && <motion.div initial={{
                  opacity: 0,
                  y: -10
                }} animate={{
                  opacity: 1,
                  y: 0
                }} exit={{
                  opacity: 0,
                  y: -10
                }} transition={{
                  duration: 0.2
                }} onMouseEnter={() => setCompanyDropdownOpen(true)} onMouseLeave={() => setCompanyDropdownOpen(false)} className="absolute top-full left-0 mt-2 w-60 bg-white rounded-lg shadow-lg border border-line py-2" data-id="element-1248" data-mp="1sxu1gkvboviu">
                      <a href="/about" className="block px-4 py-2 text-sm text-ink-dark hover:bg-surface-muted transition-colors" data-id="element-1249" data-mp="3gvcx92oig8w3">
                        <div className="font-semibold" data-id="element-1250" data-mp="deczauobpem2">About</div>
                        <div className="text-xs text-ink-muted" data-id="element-1251" data-mp="dduwtgb2i45p">
                          Mission & Vision
                        </div>
                      </a>
                      <a href="/research" className="block px-4 py-2 text-sm text-ink-dark hover:bg-surface-muted transition-colors" data-id="element-1252" data-mp="3nrqyfiukvpy">
                        <div className="font-semibold" data-id="element-1253" data-mp="w5w0cvyseilg">Research</div>
                        <div className="text-xs text-ink-muted" data-id="element-1254" data-mp="2s8scye67rjhn">
                          Architecture & priorities
                        </div>
                      </a>
                      <a href="/research-areas" className="block px-4 py-2 text-sm text-ink-dark hover:bg-surface-muted transition-colors" data-id="element-1255" data-mp="2nfph1zdyrxya">
                        <div className="font-semibold" data-id="element-1256" data-mp="3b74kxwle2nbn">Research Areas</div>
                        <div className="text-xs text-ink-muted" data-id="element-1257" data-mp="3b50kxpqm28gn">
                          The questions we study
                        </div>
                      </a>
                      <a href="/partnerships" className="block px-4 py-2 text-sm text-ink-dark hover:bg-surface-muted transition-colors" data-id="element-1258" data-mp="32554b5eadl98">
                        <div className="font-semibold" data-id="element-1259" data-mp="1qsulnrt9b5ii">Partnerships</div>
                        <div className="text-xs text-ink-muted" data-id="element-1260" data-mp="1lrx1xaslm3ew">
                          Collaborate with Us
                        </div>
                      </a>
                    </motion.div>}
                </AnimatePresence>
              </li>

              {navItems.map(item => <li key={item} data-id="element-1261" data-mp="1lleab4wzaj3p">
                  <a href={`/${item.toLowerCase()}`} className="text-sm font-medium text-ink-muted hover:text-navy transition-colors" data-id="element-1262" data-mp="1lkcoc5efcc77">
                    {item}
                  </a>
                </li>)}
            </ul>
            <div className="w-px h-5 bg-line" data-id="element-1263" data-mp="1zbzpaijba8wb"></div>
            <a href="/contact" className="bg-navy hover:bg-navy-light text-white text-sm font-medium px-5 py-2.5 rounded-md transition-colors shadow-sm whitespace-nowrap" data-id="element-1264" data-mp="24cnmjly4vlyz">
              Request Demo
            </a>
          </nav>

          {/* Mobile Menu Toggle */}
          <button className="lg:hidden text-ink-dark p-2" onClick={() => setMobileMenuOpen(!mobileMenuOpen)} aria-label="Toggle menu" data-id="element-1265" data-mp="ez0nxwxy14md">
            {mobileMenuOpen ? <X size={24} data-id="element-1266" data-mp="2yx0qhxqwltmb" /> : <Menu size={24} data-id="element-1267" data-mp="2ywiyjdb9y1k7" />}
          </button>
        </div>
      </div>

      {/* Mobile Nav Drawer */}
      <AnimatePresence data-id="element-1268" data-mp="32w1avkp154bf">
        {mobileMenuOpen && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} className="lg:hidden bg-white border-b border-line overflow-hidden" data-id="element-1269" data-mp="37x73zjmlqtlh">
            <div className="px-4 pt-2 pb-6 space-y-1 shadow-inner" data-id="element-1270" data-mp="3qmx7qw8ceppj">
              {/* Platform submenu */}
              <div className="border-b border-line pb-2 mb-2" data-id="element-1271" data-mp="3vmry8yo7hda2">
                <div className="text-xs font-semibold text-ink-muted uppercase tracking-wider px-3 py-2" data-id="element-1272" data-mp="3vk5gy7bijjen">
                  Products
                </div>
                <a href="/human-capability" className="block px-3 py-2 text-base font-medium text-ink-dark hover:bg-surface-muted rounded-md" onClick={() => setMobileMenuOpen(false)} data-id="element-1273" data-mp="ekx5naucirci">
                  Human Capability Platform
                </a>
                <a href="/cji" className="block pl-7 pr-3 py-2 text-base font-medium text-ink-dark hover:bg-surface-muted rounded-md" onClick={() => setMobileMenuOpen(false)} data-id="element-1274" data-mp="lp44bapn755">
                  CJI
                </a>
                <a href="/ncji" className="block pl-7 pr-3 py-2 text-base font-medium text-ink-dark hover:bg-surface-muted rounded-md" onClick={() => setMobileMenuOpen(false)} data-id="element-1275" data-mp="nj9604l0l3i5">
                  NCJI
                </a>
                <a href="/semantic-knowledge" className="block px-3 py-2 text-base font-medium text-ink-dark hover:bg-surface-muted rounded-md" onClick={() => setMobileMenuOpen(false)} data-id="element-1276" data-mp="1b93gwglrwhzr">
                  Semantic Knowledge Platform
                </a>
                <a href="/solutions" className="block px-3 py-2 text-base font-medium text-ink-dark hover:bg-surface-muted rounded-md" onClick={() => setMobileMenuOpen(false)} data-id="element-1277" data-mp="2vrnp9ukhob63">
                  Solutions
                </a>
              </div>

              {/* Company submenu */}
              <div className="border-b border-line pb-2 mb-2" data-id="element-1278" data-mp="2ctumqtds2398">
                <div className="text-xs font-semibold text-ink-muted uppercase tracking-wider px-3 py-2" data-id="element-1279" data-mp="2cvfl6u37q6cd">
                  Company
                </div>
                <a href="/about" className="block px-3 py-2 text-base font-medium text-ink-dark hover:bg-surface-muted rounded-md" onClick={() => setMobileMenuOpen(false)} data-id="element-1280" data-mp="b312hssugxuw">
                  About
                </a>
                <a href="/research" className="block px-3 py-2 text-base font-medium text-ink-dark hover:bg-surface-muted rounded-md" onClick={() => setMobileMenuOpen(false)} data-id="element-1281" data-mp="1vks26091jrgg">
                  Research
                </a>
                <a href="/research-areas" className="block px-3 py-2 text-base font-medium text-ink-dark hover:bg-surface-muted rounded-md" onClick={() => setMobileMenuOpen(false)} data-id="element-1282" data-mp="2j91tfhp0x7ez">
                  Research Areas
                </a>
                <a href="/partnerships" className="block px-3 py-2 text-base font-medium text-ink-dark hover:bg-surface-muted rounded-md" onClick={() => setMobileMenuOpen(false)} data-id="element-1283" data-mp="2o8ega2fwaehk">
                  Partnerships
                </a>
              </div>

              {navItems.map(item => <a key={item} href={`/${item.toLowerCase()}`} className="block px-3 py-3 text-base font-medium text-ink-dark hover:bg-surface-muted rounded-md" onClick={() => setMobileMenuOpen(false)} data-id="element-1284" data-mp="ve6l12z19pi5">
                  {item}
                </a>)}
              <div className="pt-4 px-3" data-id="element-1285" data-mp="cmnfophjdzcy">
                <a href="/contact" onClick={() => setMobileMenuOpen(false)} className="block w-full text-center bg-navy text-white font-medium px-5 py-3 rounded-md shadow-sm" data-id="element-1286" data-mp="cjhrdcgqf1ia">
                  Request Demo
                </a>
              </div>
            </div>
          </motion.div>}
      </AnimatePresence>
    </header>;
}